import { useTranslation } from '@thoughtspot/i18n';
import cx from 'classnames';
import React, { useState } from 'react';
import { Button } from '../../../button';
import { Icon, IconColor, IconID } from '../../../icon';
import { Horizontal } from '../../../layout';
import styles from '../pagination-dots.module.scss';
import { getPaginationDots, hoverPaginationDotIconID } from '../pagination-dots.util';
/**
 * The PaginationCarouselDots will replicate the behavior of a carousel, with the next and previous button functionality identical to that of a carousel.
 * Furthermore, the component will display dots indicating the current page and whether there are additional pages available or not.
 */
export const PaginationCarouselDots = ({ pages, currentPage, disablePrevious, disableNext, previous, next, jumpTo, }) => {
    const { t } = useTranslation();
    const paginationDotProp = getPaginationDots(pages, currentPage);
    if (pages < 2) {
        return React.createElement("div", { "data-testid": "empty-pagination-carousel-dots-testid" });
    }
    const getPreviousButton = () => {
        return (React.createElement(Button, { ariaLabel: t('PREVIOUS'), "data-testid": "pagination-carousel-dots-previous-button-testid", className: cx(styles.paginationLeft, {
                [styles.enabled]: disablePrevious === false,
            }), onClick: previous, isDisabled: disablePrevious, icon: IconID.CHEVRON_LEFT, iconClassName: styles.paginationIcon, type: "tertiary", size: "s", retainFocusOnClick: false }));
    };
    const getNextButton = () => {
        return (React.createElement(Button, { ariaLabel: t('NEXT'), "data-testid": "pagination-carousel-dots-next-button-testid", className: cx(styles.paginationRight, {
                [styles.enabled]: disableNext === false,
            }), onClick: next, isDisabled: disableNext, icon: IconID.CHEVRON_RIGHT, iconClassName: styles.paginationIcon, type: "tertiary", size: "s", retainFocusOnClick: false }));
    };
    const PaginationDot = ({ icon, size, pageIndex, }) => {
        const [isMouseHover, setIsMouseHover] = useState(false);
        // Selected pagination dot will not have hover effect and clickability.
        if (icon === IconID.CIRCLE) {
            return (React.createElement(Horizontal, { className: styles.dotContainer, "data-testid": `pagination-dot-${pageIndex}` },
                React.createElement(Icon, { id: icon, color: IconColor.GRAY, size: size, className: styles.dot })));
        }
        return (React.createElement(Horizontal, { className: styles.cursorPointer, onClick: () => jumpTo(pageIndex), onMouseOver: () => setIsMouseHover(true), onMouseOut: () => setIsMouseHover(false), "data-testid": `pagination-dot-${pageIndex}` },
            React.createElement(Icon, { id: isMouseHover ? hoverPaginationDotIconID : icon, color: IconColor.GRAY, size: size, className: styles.dot })));
    };
    return (React.createElement(Horizontal, { vAlignContent: "center", hAlignContent: "center", className: styles.pagination },
        getPreviousButton(),
        paginationDotProp.dots.map((paginationDot) => (React.createElement(PaginationDot, { ...paginationDot, key: paginationDot.key }))),
        getNextButton()));
};
//# sourceMappingURL=pagination-carousel-dots.js.map